import styled from 'styled-components'

export const PostDate = styled.p`
  font-size: 2.0rem;
  font-weight: 300;
  margin-bottom: 20px;
`
